import React from 'react';
import PropTypes from 'prop-types';
import { URLS } from 'consts';
import { useMediaSet } from 'use-media-set';
import { mediaSetQueries } from 'styleGuide';
import LinkButton from 'components/ui/buttons/LinkButton';

const ProjectButtonByCondition = ({ onProjectView, talentBidStatus, slug }) => {
  const mediaStates = useMediaSet(mediaSetQueries);
  const getButtonText = talentBidStatus => {
    if (talentBidStatus) {
      return talentBidStatus === 'draft' ? 'Finish Draft' : 'Applied';
    } else {
      return 'Learn More';
    }
  };

  const buttonText = getButtonText(talentBidStatus);
  const buttonColorIsDark = buttonText === 'Applied';

  return (
    <LinkButton
      id={`project-button-${slug}`}
      data-testid={`project-button-${slug}`}
      className="d-block d-sm-inline-block flex-grow-1"
      href={URLS.project(slug)}
      dark={buttonColorIsDark}
      onClick={onProjectView}
      size={mediaStates.has('mobile') ? 'md' : 'sm'}
    >
      {buttonText}
    </LinkButton>
  );
};

ProjectButtonByCondition.propTypes = {
  onProjectView: PropTypes.func,
  slug: PropTypes.string,
  talentBidStatus: PropTypes.string,
};

export default ProjectButtonByCondition;
